import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { CheckboxInput2023Expects } from "../../../Common";

interface AuthorizeDeliveryToBeLeftWithoutSignatureFormLogicPureProps {
  ref: React44ms.Api.TypedRef<CheckboxInput2023Expects>;
}
const AuthorizeDeliveryToBeLeftWithoutSignatureFormLogicPure: React44ms.Api.FunctionComponent<
  AuthorizeDeliveryToBeLeftWithoutSignatureFormLogicPureProps
> = (props) => {
  const [value, setValue] = React44ms.Api.useState(true);

  const handleChange: React44ms.Api.input["onChange"] =
    React44ms.Api.useCallback((event) => {
      setValue(event.target.value);
    }, []);

  const outputValue: CheckboxInput2023Expects = React44ms.Api.useMemo(
    () => ({
      value: !!value,
    }),
    [value]
  );

  return (
    <form>
      <input React44ms_onChange={handleChange} />
      <output React44ms_value={outputValue} />
    </form>
  );
};

export const AuthorizeDeliveryToBeLeftWithoutSignatureFormLogic =
  React44ms.React.Reactify(
    AuthorizeDeliveryToBeLeftWithoutSignatureFormLogicPure
  );
